import React, { useEffect, useState } from 'react';
import { Navigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Building2, ArrowLeft, Info } from 'lucide-react';
import Header from '../components/Header';
import MyOrganizationsSection from '../components/MyOrganizationsSection';
import OrgStatsPanel from '../components/OrgStatsPanel';
import { API, useAuth } from '../App';

const Organisations = () => {
  const { user } = useAuth();
  const [checking, setChecking] = useState(true);
  const [hasOrg, setHasOrg] = useState(false);

  useEffect(() => {
    if (!user) return;
    let alive = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/organizations/my`);
        if (alive) setHasOrg((res.data || []).length > 0);
      } catch { if (alive) setHasOrg(false); }
      finally { if (alive) setChecking(false); }
    })();
    return () => { alive = false; };
  }, [user]);

  if (!user) return <Navigate to="/login" replace />;

  if (checking) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="flex items-center justify-center py-24">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background" data-testid="organisations-page">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6 flex items-start justify-between gap-4 flex-wrap">
          <div>
            <Link to="/dashboard" className="inline-flex items-center gap-1 text-sm font-bold text-charcoal/60 hover:text-charcoal mb-2" data-testid="orgs-back-dashboard">
              <ArrowLeft className="w-4 h-4" /> Retour au dashboard
            </Link>
            <h1 className="font-heading font-bold text-3xl sm:text-4xl text-charcoal flex items-center gap-2">
              <Building2 className="w-7 h-7" /> Mes organisations
            </h1>
            <p className="text-sm text-charcoal/60 mt-1">Generez vos PingMes, gerez votre branding, vos admins et vos categories d'objets.</p>
          </div>
        </div>

        {hasOrg ? (
          <>
            <OrgStatsPanel />
            <MyOrganizationsSection hideHeader />
          </>
        ) : (
          <div className="card-brutal text-center py-12 max-w-xl mx-auto" data-testid="no-orgs-state">
            <div className="bg-primary/20 w-20 h-20 rounded-full border-2 border-charcoal flex items-center justify-center mx-auto mb-4">
              <Info className="w-10 h-10 text-charcoal" />
            </div>
            <h2 className="text-xl font-heading font-bold text-charcoal mb-2">Vous n'etes admin d'aucune organisation</h2>
            <p className="text-sm text-charcoal/70 mb-4">
              Cette page est reservee aux administrateurs d'organisation. Si vous representez une marque, une flotte ou une ecole,
              contactez-nous pour creer votre organisation.
            </p>
            <Link to="/business" className="btn-primary inline-flex items-center gap-2">
              Decouvrir l'offre entreprise
            </Link>
          </div>
        )}
      </main>
    </div>
  );
};

export default Organisations;
